import React, { useMemo } from 'react'

import { Alert, Box } from '@mui/material'
import { loadConnectAndInitialize } from '@stripe/connect-js'
import { ConnectAccountOnboarding, ConnectComponentsProvider } from '@stripe/react-connect-js'

import env from '../../../networkRequests/apiClient/env.config'
import theme from '../../styles/themes/default.theme'
import styles from './StripeConnectOnboardingForm.styles'
import { StripeConnectOnboardingFormProps } from './StripeConnectOnboardingForm.types'

const StripeConnectOnboardingForm: React.FC<StripeConnectOnboardingFormProps> = ({
  accountSessionClientSecret,
  onOnboardingComplete
}: StripeConnectOnboardingFormProps) => {
  const stripeConnectInstance = useMemo(() => {
    const stripeConnectInstance = loadConnectAndInitialize({
      publishableKey: env.STRIPE_PUBLISHABLE_KEY,
      fetchClientSecret: async () => accountSessionClientSecret,
      appearance: {
        overlays: 'dialog',
        variables: {
          colorPrimary: theme.palette.primary.main
        }
      }
    })

    return stripeConnectInstance
  }, [accountSessionClientSecret])

  return (
    <Box sx={styles.container}>
      <Alert severity="info" sx={styles.infoAlert}>
        Please select Individual as your Business Type before continuing.
      </Alert>

      <ConnectComponentsProvider connectInstance={stripeConnectInstance}>
        <ConnectAccountOnboarding
          onExit={onOnboardingComplete}
          collectionOptions={{
            fields: 'eventually_due',
            futureRequirements: 'include'
          }}
        />
      </ConnectComponentsProvider>
    </Box>
  )
}

export default StripeConnectOnboardingForm
